<template>
    <main class="flex min-h-[calc(100vh-4.5rem)] items-center justify-center bg-nomad-greenish px-6 py-20 text-center text-nomad-primary">
      <div class="max-w-xl rounded-[2rem] bg-white px-8 py-12 shadow-[0_1rem_2.5rem_rgba(23,25,35,0.08)] sm:px-16">
        <p class="text-sm font-extrabold uppercase tracking-[0.16em] text-nomad-accent">404</p>
        <h1 class="mt-4 text-4xl font-extrabold tracking-tight sm:text-5xl">Page not found</h1>
        <p class="mt-4 text-base leading-relaxed text-[#5F626D]">Sorry, the page you are looking for does not exist.</p>
        <router-link to="/" class="mt-8 inline-flex rounded-full bg-nomad-primary px-5 py-3 text-sm font-extrabold text-white transition hover:bg-black">Go home</router-link>
      </div>
    </main>
  </template>
  
  <script>
  export default {
    name: 'NotFound',
  }
  </script>
  
